import { render, staticRenderFns } from "./LegalAddress.vue?vue&type=template&id=137bf7b0&scoped=true"
import script from "./LegalAddress.vue?vue&type=script&lang=js"
export * from "./LegalAddress.vue?vue&type=script&lang=js"
import style0 from "./LegalAddress.vue?vue&type=style&index=0&id=137bf7b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137bf7b0",
  null
  
)

export default component.exports